import { ButtonType } from './button-type';
import { loadingClass } from './loading-class';

export const commonButtonClasses = (
  type: ButtonType,
  prefix: string,
  loading: boolean,
): (string | undefined
  )[] => [
  `${prefix}btn`,
  `${prefix}btn--${type}`,
  loadingClass(loading, prefix),
];
